import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class ProtocolService {
  protocolAccepted = new EventEmitter();

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/shared/global/protocol.service.ts